import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Modal, TableBody, TableRow, TableCell } from '@mui/material';

import EnhancedTable from '../../../../components/EnhancedTable';
import { ReactComponent as CloseIcon } from '../../../../assets/images/close-modal.svg';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 645,
  minHeight: 260,
  bgcolor: 'background.paper',
  boxShadow: '0px 12px 32px rgba(42, 70, 94, 0.03)',
  borderRadius: '12px',
  outline: 'none',
  maxHeight: 700
};

export const BoxInfo = ({
  title,
  sum,
  prefixSum,
  idNumber,
  titleModal,
  labelTable,
  contentTable,
  hiddenModal = false,
  hiddenDebt = false,
  debt,
  ...props
}) => {
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState({
    page: 0,
    size: 1,
    orderBy: 'id',
    orderType: 'desc',
  });

  const findDebtInTable = contentTable?.find((cell) => cell.balance < 0);

  return (
    <Box
      {...props}
      sx={{
        background: '#F3F5F6',
        borderRadius: '8px',
        minWidth: '200px',
        maxWidth: '254px',
        minHeight: '166px',
        padding: '16px',
        ...props?.sx
      }}>
      <Typography>{title}</Typography>
      <Typography variant="h5" sx={{ fontSize: '26px', fontWeight: 500 }}>
        {Math.abs(sum)} {prefixSum}
      </Typography>
      {!hiddenDebt && (
        <>
          {debt && debt > 0 ? (
            <Typography color="error.main" data-testid="HasDebt">Есть задолженность</Typography>
          ) : (
            <Typography color="success.main">Нет задолженности</Typography>
          )}
        </>
      )}

      <Typography sx={{ fontSize: '16px', color: 'text.secondary', marginTop: '16px' }}>
        {idNumber}
      </Typography>

      {!hiddenModal && (
        <>
          <Typography
            onClick={() => setShowModal(true)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '16px',
              color: 'primary.main',
              fontWeight: 500,
              marginTop: '16px',
              cursor: 'pointer'
            }}
            data-testid="SeeAll"
          >
            Просмотреть все
            {findDebtInTable && (
              <Box
                sx={{ backgroundColor: 'error.main', borderRadius: '8px', marginLeft: '8px' }}
                height="8px"
                width="8px"
                data-testid="findDebtInTable"
              />
            )}
          </Typography>

          <Modal open={showModal} onClose={() => setShowModal(false)} data-testid="Modal">
            <Box sx={style}>
              <Box
                p="24px"
                borderBottom="1px solid #DDE1E5"
                display="flex"
                justifyContent="space-between"
                alignItems="center">
                <Typography variant="h5" fontWeight={500}>
                  {titleModal}
                </Typography>
                <Box sx={{ cursor: 'pointer' }}>
                  <CloseIcon onClick={() => setShowModal(false)} data-testid="CloseModal"/>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: '24px',
                  overflowY: 'scroll',
                  maxHeight: '600px'
                }}
              >
                <EnhancedTable
                  rows={[]}
                  headCells={[
                    {
                      id: 'number',
                      label: labelTable[0],
                      sx: { whiteSpace: 'nowrap'},
                    },
                    {
                      id: 'balance',
                      label: labelTable[1],
                      sx: { whiteSpace: 'nowrap'},
                    },
                    {
                      id: 'debt',
                      label: labelTable[2],
                    }
                  ]}
                  filter={filter}
                  total={2}
                  setFilter={setFilter}
                  showPagination={false}
                  hideOrderFromDOM={true}
                >
                  <TableBody
                    sx={{
                      'tr:last-child  td': {
                        borderBottom: 'none'
                      }
                    }}
                  >
                    {contentTable?.map((cell) => (
                      <TableRow key={cell.id}>
                        <TableCell>{cell.id}</TableCell>
                        <TableCell>{cell.balance} ₸</TableCell>
                        <TableCell>
                          {cell.debt && cell.debt > 0 ? <Box color="error.main">Да</Box> : <Box>Нет</Box>}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </EnhancedTable>
              </Box>
            </Box>
          </Modal>
        </>
      )}
    </Box>
  );
};

BoxInfo.propTypes = {
  title: PropTypes.string,
  sum: PropTypes.string,
  idNumber: PropTypes.number,
  sx: PropTypes.any,
  titleModal: PropTypes.node,
  contentModal: PropTypes.string,
  labelTable: PropTypes.array,
  contentTable: PropTypes.array,
  hiddenModal: PropTypes.bool,
  hiddenDebt: PropTypes.bool,
  debt: PropTypes.string,
  prefixSum: PropTypes.string,
};
